export default {
    label_task:{
        en:"User Groups",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New user Group",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit user Group",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of user Group",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_num_tasks:{
        en:"Number of tasks",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_assign_role:{
        en:"Assign Role",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_task_name:{
        en:"Assign Role",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}